import React, { useEffect, useState } from 'react'
import TopHashtagItem2 from '../../../../components/public/pages/home/topHashtagItem2'
import ApiUrl from '../../../../configTools/apiUrl';

const Tophashtags = () => {
    const [tophashtags, setHashtags] = useState([]);
    useEffect(()=>{
        fetch(ApiUrl.API_URL_TopHashtag)
        .then(res=>res.json())
        .then(data =>{
            setHashtags(data);
        });
    },[])
  return (
    <div className='public_home_explore_topsearches'>
        <div className='public_home_product_grid_3_container'>
        <div className='public_home_product_grid_1_title'>
            <div className='public_home_product_grid_1_title_details'>
                <h4>Top Hashtags</h4>
                <p>Following are the most used hashtags</p>
            </div>
        </div>
        <div className='public_home_tophashtag_wrapper'>
            <div className='public_home_tophashtag_container'>
            {
                tophashtags.map((product,index)=>{
                    return(
                        <div className='public_home_tophashtag_item_container' key={index}>
                            <TopHashtagItem2 Product={product} />
                        </div>
                    )
                })
            }
            </div>
        </div>
        </div>
    </div>
  )
}

export default Tophashtags
